import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from "@components/mantine";
import { IconTag, IconDatabase, IconStack2, IconFileDescription, IconCloudUpload, IconCodeDots, IconSitemap, IconWorld } from "@coveord/plasma-react-icons";
import { SourceType } from "@core/api";
import amazonS3 from "./source-type-image/amazonS3.svg";
import box from "./source-type-image/box.svg";
import confluence from "./source-type-image/confluence.svg";
import dropbox from "./source-type-image/dropbox.svg";
import googleDrive from "./source-type-image/google-drive.svg";
import graphQl from "./source-type-image/graphql.svg";
import jira from "./source-type-image/jira.svg";
import jive from "./source-type-image/jive.svg";
import khoros from "./source-type-image/khoros.svg";
import microsoftDynamics from "./source-type-image/microsoft-dynamics.svg";
import rss from "./source-type-image/rss.svg";
import salesforce from "./source-type-image/salesforce.svg";
import SAP from "./source-type-image/sap.svg";
import servicenow from "./source-type-image/servicenow.svg";
import sharepointOnline from "./source-type-image/sharepoint-online.svg";
import shopify from "./source-type-image/shopify.svg";
import sitecore from "./source-type-image/sitecore.svg";
import slack from "./source-type-image/slack.svg";
import youtube from "./source-type-image/youtube.svg";
import zendesk from "./source-type-image/zendesk.svg";
import { Locales } from "../strings/Locales";
import { SourceIdentityHelper } from "../source/source-identity/SourceIdentityHelper.js";
var _obj;
var SourceImages = (_obj = {}, _define_property(_obj, SourceType.AMAZONS3, /*#__PURE__*/ _jsx(Image, {
    src: amazonS3,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.AMAZONS3)
    })
})), _define_property(_obj, SourceType.BOX_ENTERPRISE2, /*#__PURE__*/ _jsx(Image, {
    src: box,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.BOX_ENTERPRISE2)
    })
})), _define_property(_obj, SourceType.CONFLUENCE, /*#__PURE__*/ _jsx(Image, {
    src: confluence,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.CONFLUENCE)
    })
})), _define_property(_obj, SourceType.CONFLUENCE2, /*#__PURE__*/ _jsx(Image, {
    src: confluence,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.CONFLUENCE2)
    })
})), _define_property(_obj, SourceType.CONFLUENCE2_HOSTED, /*#__PURE__*/ _jsx(Image, {
    src: confluence,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.CONFLUENCE2_HOSTED)
    })
})), _define_property(_obj, SourceType.DROPBOX_FOR_BUSINESS, /*#__PURE__*/ _jsx(Image, {
    src: dropbox,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.DROPBOX_FOR_BUSINESS)
    })
})), _define_property(_obj, SourceType.GOOGLE_DRIVE_DOMAIN_WIDE, /*#__PURE__*/ _jsx(Image, {
    src: googleDrive,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.GOOGLE_DRIVE_DOMAIN_WIDE)
    })
})), _define_property(_obj, SourceType.GRAPHQL, /*#__PURE__*/ _jsx(Image, {
    src: graphQl,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.GRAPHQL)
    })
})), _define_property(_obj, SourceType.JIRA2, /*#__PURE__*/ _jsx(Image, {
    src: jira,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.JIRA2)
    })
})), _define_property(_obj, SourceType.JIRA2_HOSTED, /*#__PURE__*/ _jsx(Image, {
    src: jira,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.JIRA2_HOSTED)
    })
})), _define_property(_obj, SourceType.JIVE, /*#__PURE__*/ _jsx(Image, {
    src: jive,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.JIVE)
    })
})), _define_property(_obj, SourceType.JIVE_HOSTED, /*#__PURE__*/ _jsx(Image, {
    src: jive,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.JIVE_HOSTED)
    })
})), _define_property(_obj, SourceType.KHOROS, /*#__PURE__*/ _jsx(Image, {
    src: khoros,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.KHOROS)
    })
})), _define_property(_obj, SourceType.LITHIUM, /*#__PURE__*/ _jsx(Image, {
    src: khoros,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.LITHIUM)
    })
})), _define_property(_obj, SourceType.MICROSOFT_DYNAMICS, /*#__PURE__*/ _jsx(Image, {
    src: microsoftDynamics,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.MICROSOFT_DYNAMICS)
    })
})), _define_property(_obj, SourceType.RSS, /*#__PURE__*/ _jsx(Image, {
    src: rss,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.RSS)
    })
})), _define_property(_obj, SourceType.SALESFORCE, /*#__PURE__*/ _jsx(Image, {
    src: salesforce,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.SALESFORCE)
    })
})), _define_property(_obj, SourceType.SALESFORCE_SITES, /*#__PURE__*/ _jsx(Image, {
    src: salesforce,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.SALESFORCE_SITES)
    })
})), _define_property(_obj, SourceType.SAP, /*#__PURE__*/ _jsx(Image, {
    src: SAP,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.SAP)
    })
})), _define_property(_obj, SourceType.SERVICENOW, /*#__PURE__*/ _jsx(Image, {
    src: servicenow,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.SERVICENOW)
    })
})), _define_property(_obj, SourceType.SHAREPOINT, /*#__PURE__*/ _jsx(Image, {
    src: sharepointOnline,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.SHAREPOINT)
    })
})), _define_property(_obj, SourceType.SHAREPOINT_ONLINE2, /*#__PURE__*/ _jsx(Image, {
    src: sharepointOnline,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.SHAREPOINT_ONLINE2)
    })
})), _define_property(_obj, SourceType.SHOPIFY, /*#__PURE__*/ _jsx(Image, {
    src: shopify,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.SHOPIFY)
    })
})), _define_property(_obj, SourceType.SITECORE, /*#__PURE__*/ _jsx(Image, {
    src: sitecore,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.SITECORE)
    })
})), _define_property(_obj, SourceType.SLACK, /*#__PURE__*/ _jsx(Image, {
    src: slack,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.SLACK)
    })
})), _define_property(_obj, SourceType.YOUTUBE, /*#__PURE__*/ _jsx(Image, {
    src: youtube,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.YOUTUBE)
    })
})), _define_property(_obj, SourceType.ZENDESK, /*#__PURE__*/ _jsx(Image, {
    src: zendesk,
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.ZENDESK)
    })
})), _obj);
var _obj1;
var SourceIcons = (_obj1 = {}, _define_property(_obj1, SourceType.CATALOG, /*#__PURE__*/ _jsx(IconTag, {
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.CATALOG)
    })
})), _define_property(_obj1, SourceType.CUSTOM, /*#__PURE__*/ _jsx(IconStack2, {
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.CUSTOM)
    })
})), _define_property(_obj1, SourceType.DATABASE, /*#__PURE__*/ _jsx(IconDatabase, {
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.DATABASE)
    })
})), _define_property(_obj1, SourceType.FILE, /*#__PURE__*/ _jsx(IconFileDescription, {
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.FILE)
    })
})), _define_property(_obj1, SourceType.GENERIC_REST, /*#__PURE__*/ _jsx(IconCodeDots, {
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.GENERIC_REST)
    })
})), _define_property(_obj1, SourceType.PUSH, /*#__PURE__*/ _jsx(IconCloudUpload, {
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.PUSH)
    })
})), _define_property(_obj1, SourceType.SITEMAP, /*#__PURE__*/ _jsx(IconSitemap, {
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.SITEMAP)
    })
})), _define_property(_obj1, SourceType.WEB2, /*#__PURE__*/ _jsx(IconWorld, {
    "aria-label": Locales.format("SourceIdentity.TypeImage.ariaLabel", {
        sourceType: SourceIdentityHelper.getSourceTypeLabel(SourceType.WEB2)
    })
})), _obj1);
export var SOURCE_TYPE_ICON_MAPPINGS = _object_spread({}, SourceImages, SourceIcons);

//# sourceMappingURL=SourceTypeIconMappings.js.map